import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import {Alert, Box, Divider, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import { ExpenditureItem } from '../../../types/reports/expenditureItem';

interface Props{
    items: ExpenditureItem[];
    totalCount: number;
    searchInput: string;
}

const ExpenditureList = (props: Props): JSX.Element => {

    return (
     <Box>
        <Typography
            variant="h6"
            align={'left'}
            sx={{
            fontWeight: 700,
            }}
            color={'secondary'}
            paddingTop={2}
            gutterBottom
        >
        Latest Expenditures
        </Typography>
        <Divider textAlign="right">
            <Typography component={'i'} variant='body2' color="primary">{props.totalCount} total result(s)</Typography>
        </Divider>
        <Grid container marginTop={3}>
          <Grid size={{xs:12, md:10}}>
            <Box marginBottom={2}>
                <Alert icon={false} severity="success">
                    There are <b>{props.totalCount}</b> expenditures from vendor with the name <b>{props.searchInput}</b>. The latest 10 are displayed below.
                </Alert>
            </Box>
            <TableContainer component={Paper}>   
                <Table aria-label="expenditure data table" size="small">
                    <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                        <TableRow>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                     Date
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                     Vendor
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                    Filer/Source
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                     Amount
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                    Purpose
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.items?.map((item) => (
                            <TableRow key={item.id}
                                 sx={{
                                     '&:last-child td, &:last-child th': { border: 0 },
                                 }}
                            >
                                <TableCell>
                                    <Typography variant={'subtitle2'}>
                                        {item.date}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle2" fontWeight={550}>{item.vendor}</Typography>
                                    <Typography component={'i'} variant="subtitle2" color="primary">{item.clarifiedName}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle2">
                                         <Typography marginRight={0.5} component={Link} href={`/filers?q=${item.filerCpfId}`} target="_blank" underline="hover" variant="body2">{item.filerCpfId}</Typography>
                                            {item.filerFullNameReverse}
                                        {item.filerFullNameReverse}
                                    </Typography>
                                    <Typography component={Link} href={`/reports/displayreport?id=${item.reportId}`} target="_blank" underline="hover" variant="body2"><i>{item.sourceDescription}</i></Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant={'subtitle2'}>
                                        {item.amount}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle2">{item.purpose}</Typography>
                                    <Typography component={'i'} variant="subtitle2" color="primary">{item.clarifiedPurpose}</Typography>
                                </TableCell>
                            </TableRow>
                             ))}
                         </TableBody>
                     </Table>
            </TableContainer>
          </Grid>
                {
                    props.totalCount > 10 && 
                    <Grid size={10} display="flex" justifyContent="flex-end" marginTop={2}>
                        <Link href={`/Data/SearchItems?schedule=B&name=${props.searchInput}`} underline='hover' fontSize={"small"}><i>View All Expenditures</i></Link>
                    </Grid>
                }
        </Grid>
  </Box>
  );
};

export default ExpenditureList;